
import { Footer } from 'flowbite-react';

const SignupBoxSection = () => {
    
    return (
        <div className={`relative w-full bg-tertiary-dark border-t border-gray-700 rounded-t-2xl`} >
            <div className={`mx-auto w-full px-36 xs:px-0 py-6 relative  `} >
                <div className="flex items-center justify-center pb-10 " >
                    <img src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencelogo.webp" className="mr-3 h-6 sm:h-9" alt="Flowbite React Logo" />
                    <div className="text-center"><span className="text-blue-700 text-xl font-semibold font-['Inter']">Cadence</span><span className="text-blue-800 text-xl font-semibold font-['Inter']">pro</span></div>
                </div>
                <div className="w-full justify-center  sm:flex sm:items-center pb-10 xs:py-5">
                    <Footer.LinkGroup className="gap-5 justify-center">
                        <Footer.Link className="text-white" href="/about">About</Footer.Link>
                        <Footer.Link className="text-white" href="/privacy-policy">Privacy Policy</Footer.Link>
                        <Footer.Link className="text-white" href="/terms-of-service">Terms of Service</Footer.Link>
                        <Footer.Link className="text-white" href="/help-center">Help Center</Footer.Link>
                        {/* <Footer.Link className="text-white" href="/licensing">Licensing</Footer.Link> */}
                        <Footer.Link className="text-white" href="/book-a-demo">Contact</Footer.Link>
                    </Footer.LinkGroup>
                </div>
                <Footer.Divider />
                <Footer container theme={{root:{base:"bg-gray-900"}} }>
                    <div className="w-full text-center bg-gray-900">
                        <Footer.Copyright href="#" by="Cadence Pro Inc. All Rights Reserved." year={2024} />
                    </div>
                </Footer>
            </div>
        </div>
    )
}

export default SignupBoxSection;